import React, { useMemo } from 'react';
import Link from '../Link';
import InlinePreview from '../shared/InlinePreview';
import { extractYoutubeVideoId } from './youtube';
import YoutubePreview from './YoutubePreview';
const PreviewableLink = React.forwardRef((props, ref) => {
    const youtubeVideoId = useMemo(() => props.href && extractYoutubeVideoId(props.href), [props.href]);
    if (youtubeVideoId) {
        return (React.createElement(InlinePreview, { ref: ref, preview: React.createElement(YoutubePreview, { videoId: youtubeVideoId }) },
            React.createElement(Link, Object.assign({}, props))));
    }
    return React.createElement(Link, Object.assign({}, props));
});
PreviewableLink.displayName = 'PreviewableLink';
export default React.memo(PreviewableLink);
//# sourceMappingURL=index.js.map